var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotesVbo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.875H15.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13H15.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 16.125H12.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3014 21.5938H4.6875C4.4803 21.5938 4.28159 21.5114 4.13507 21.3649C3.98856 21.2184 3.90625 21.0197 3.90625 20.8125V5.1875C3.90625 4.9803 3.98856 4.78159 4.13507 4.63507C4.28159 4.48856 4.4803 4.40625 4.6875 4.40625H20.3125C20.5197 4.40625 20.7184 4.48856 20.8649 4.63507C21.0114 4.78159 21.0938 4.9803 21.0938 5.1875V15.8014C21.0938 15.904 21.0735 16.0056 21.0343 16.1004C20.995 16.1952 20.9375 16.2813 20.8649 16.3538L15.8538 21.3649C15.7813 21.4375 15.6952 21.495 15.6004 21.5343C15.5056 21.5735 15.404 21.5938 15.3014 21.5938V21.5938Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.023 16.1242H15.625V21.5226",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesVbo);
export default __webpack_public_path__ + "static/media/NotesVBO.556e6baec8c49d97560de3fd4b5e5b04.svg";
export { ForwardRef as ReactComponent };